import { observer } from 'mobx-react-lite'
import { lazy, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'

import { useStore } from 'store/useStore'
import { ContainerLK } from 'sections/LKSection/shared/components/ContainerLK/ContainerLK'
import { Margin, Padding } from 'components/ui'
import { Button, Flex, Title } from 'components/uiKit'
import { useResize } from 'utils/hooks/useResize'

import { ActivityStep } from '../../components/PersonalDataSteps/ActivityStep/ActivityStep'

const EditRequisitesPage = observer(() => {
  const { profileUiStore: uiStore } = useStore()
  const { companyDetails } = uiStore
  const { isMobile } = useResize()
  const navigate = useNavigate()

  useEffect(() => {
    uiStore.createEditData()
    return () => {
      companyDetails.clearCompanyInfo()
    }
  }, [])

  const backButtonHandler = () => {
    navigate(-1)
    uiStore.companyDetails.clearCompanyInfo()
  }

  const updateRequisites = () => {
    uiStore.apiStore.updateRequisites().then(() => {
      navigate(-1)
    })
  }

  return (
    <ContainerLK>
      <Padding py={32}>
        <Margin mt={isMobile ? 0 : 50} mb={isMobile ? 40 : 80}>
          <Flex gap={16} align="center">
            <Button shape="circle" icon={<ArrowLeftOutlined />} onClick={backButtonHandler} />
            <Title>Редактирование реквизитов</Title>
          </Flex>
        </Margin>

        <ActivityStep companyDetails={uiStore.companyDetails} isEdit />

        <Button
          onClick={updateRequisites}
          disabled={uiStore.validateStore.isInvalidRequisitesData || uiStore.isSendingData}
          loading={uiStore.isSendingData}
        >
          Обновить
        </Button>
      </Padding>
    </ContainerLK>
  )
})

export default EditRequisitesPage

export const EditRequisitesPageAsync = lazy(() => import('./EditRequisitesPage'))
